<div *ngIf="page_loaded">
	<div class="new-summary-section">
		<div class="each-new-summary-section">
			<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data.total_assigned_clients) }}</p>
			<p class="each-new-summary-section-label">Total Assigned Clients</p>
		</div>
		<div class="each-new-summary-section">
			<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data.total_opportunities) }}</p>
			<p class="each-new-summary-section-label">Upside Opportunities</p>
		</div>
		<div class="each-new-summary-section">
			<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data.total_retention) }}</p>
			<p class="each-new-summary-section-label">Retention Opportunities</p>
		</div>
		<div class="each-new-summary-section">
			<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_data.total_client_engagement) }}</p>
			<p class="each-new-summary-section-label">Client Engagement Opportunities</p>
		</div>
		<div class="each-new-summary-section">
			<div class="each-new-summary-section-switch">
				<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_page_graphs" (change)="toggleGraphs()" ></mat-slide-toggle>
			</div>
			<p class="each-new-summary-section-label">Graphical Representation</p>
		</div>
	</div>

    <!-- <ng-container>
		<app-agent-one-view [type]="'MAGI (for existing clients)'"></app-agent-one-view>
	</ng-container> -->

    <!-- <ng-container>
		<app-agent-three-view [type]="'MAGI (for existing clients)'"></app-agent-three-view>
	</ng-container> -->

	<div class="optimize-charts-section" *ngIf="show_page_graphs">
		<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="graphSlideConfig">
            <div ngxSlickItem class="each-dashboard-graph-block">
                <div class="portfolio-inner-heading-section">
                    <img src="assets/events.png" class="portfolio-section-icon" />
                    <span>Opportunities by Year</span>
                </div>
                <div class="each-dashboard-graph-content">
                    <div id="opp-year-graph"></div>
                </div>
            </div>
            <div ngxSlickItem class="each-dashboard-graph-block">
                <div class="portfolio-inner-heading-section">
                    <img src="assets/events.png" class="portfolio-section-icon" />
                    <span>Clients by AI Assigned</span>
                </div>
                <div class="each-dashboard-graph-content">
                    <div id="ai-assigned-graph"></div>
                </div>
            </div>
            <div ngxSlickItem class="each-dashboard-graph-block">
                <div class="portfolio-inner-heading-section">
                    <img src="assets/events.png" class="portfolio-section-icon" />
                    <span>Clients by Type</span>
                </div>
                <div class="each-dashboard-graph-content">
                    <div id="type-graph"></div>
                </div>
            </div>
            <div ngxSlickItem class="each-dashboard-graph-block">
                <div class="portfolio-inner-heading-section">
                    <img src="assets/events.png" class="portfolio-section-icon" />
                    <!-- <span>AI Advisor Assistant Activities</span> -->
                    <span>MAGI Activities</span>
                </div>
                <div class="each-dashboard-graph-content">
                    <div id="ai-advisor-assistant-activities-graph"></div>
                </div>
            </div>
            <div ngxSlickItem class="each-dashboard-graph-block">
                <div class="portfolio-inner-heading-section">
                    <img src="assets/events.png" class="portfolio-section-icon" />
                    <!-- <span>Clients by AI Advisor Assistant Trigger</span> -->
                    <span>Clients by MAGI Trigger</span>
                </div>
                <div class="each-dashboard-graph-content">
                    <div id="ai-advisor-assistant-trigger-graph"></div>
                </div>
            </div>
            <div ngxSlickItem class="each-dashboard-graph-block">
                <div class="portfolio-inner-heading-section">
                    <img src="assets/events.png" class="portfolio-section-icon" />
                    <span>Clients by Products</span>
                </div>
                <div class="each-dashboard-graph-content">
                    <div id="products-graph"></div>
                </div>
            </div>
            <div ngxSlickItem class="each-dashboard-graph-block">
                <div class="portfolio-inner-heading-section">
                    <img src="assets/events.png" class="portfolio-section-icon" />
                    <span>Clients by Age Group</span>
                </div>
                <div class="each-dashboard-graph-content">
                    <div id="age-group-graph"></div>
                </div>
            </div>
            <div ngxSlickItem class="each-dashboard-graph-block">
                <div class="portfolio-inner-heading-section">
                    <img src="assets/events.png" class="portfolio-section-icon" />
                    <span>Clients by AUM</span>
                </div>
                <div class="each-dashboard-graph-content">
                    <div id="aum-graph"></div>
                </div>
            </div>
	    </ngx-slick-carousel>
    </div>
    <div>
        <div class="portfolio-inner-heading-section">
            <img src="assets/interaction-summary.png" class="portfolio-section-icon" />
            <!-- <span>AI Advisor Assistant Clients Summary</span> -->
            <span>MAGI Clients Summary</span>
            <!-- <span>AI Assistant Clients Summary</span> -->
        </div>
        <div class="leads-table-section">
            <div class="new-table-heading-section">
                <div class="mb-2">
                    <span class="new-filter-tag" *ngIf="opp_year_id != ''">
                        {{ opp_year_name }}
                        <img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" opp_year_id = ''; opp_year_name = ''; current_pagination_page = 1; getClientsData()" />
                    </span>
                    <span class="new-filter-tag" *ngIf="type_id != ''">
                        {{ type_name }}
                        <img
                            src="assets/filter-tag-close.png"
                            class="filter-close-icon"
                            (click)="
                            type_id = '';
                            type_name = '';
                            current_pagination_page = 1;
                            getClientsData()"
                        />
                    </span>
                    <span class="new-filter-tag" *ngIf="ai_advisor_assistant_trigger_id != ''">
                        {{ ai_advisor_assistant_trigger_name }}
                        <img
                            src="assets/filter-tag-close.png"
                            class="filter-close-icon"
                            (click)="
                            ai_advisor_assistant_trigger_id = '';
                            ai_advisor_assistant_trigger_name = '';
                            current_pagination_page = 1;
                            getClientsData()"
                        />
                    </span>
                    <span class="new-filter-tag" *ngIf="product_id != ''">
                        {{ product_name }}
                        <img
                            src="assets/filter-tag-close.png"
                            class="filter-close-icon"
                            (click)="
                            product_id = '';
                            product_name = '';
                            current_pagination_page = 1;
                            getClientsData()"
                        />
                    </span>
                    <span class="new-filter-tag" *ngIf="age_group_id != ''">
                        {{ age_group_name }}
                        <img
                            src="assets/filter-tag-close.png"
                            class="filter-close-icon"
                            (click)="
                            age_group_name = '';
                            age_group_id = '';
                            current_pagination_page = 1;
                            getClientsData()"
                        />
                    </span>
                    <span class="new-filter-tag" *ngIf="aum_min_id != ''">
                        {{ aum_min_id }} - {{ aum_max_id }}
                        <img
                        src="assets/filter-tag-close.png"
                        class="filter-close-icon"
                        (click)="
                        aum_min_id = '';
                        aum_max_id = '';
                        current_pagination_page = 1;
                        getClientsData()
                        "
                        />
                    </span>
                </div>
                <button class="move-button" style="margin-right: 16px; position: relative; top: 6px;" (click)="captureResponse()">Capture Response</button>
                <!-- <span style="visibility: hidden">AI Advisor Assistant Clients</span> -->
                <!-- <span style="visibility: hidden">AI Assistant Clients</span> -->
                <span style="visibility: hidden">MAGI Clients</span>
                <div class="new-table-actions ml-4">
                    <div class="each-action-section search-input-section" *ngIf="show_search">
                        <input
                            type="text"
                            placeholder="Search"
                            class="search-input"
                            [(ngModel)]="search_key"
                            (input)="current_pagination_page = 1; getClientsData()"
                        />
                        <span
                            class="search-input-close"
                            (click)="
                            show_search = false;
                            search_key = '';
                            current_pagination_page = 1;
                            getClientsData()">&times;
                        </span>
                    </div>
                    <div class="each-action-section search-icon" *ngIf="!show_search" (click)="show_search = true">
                        <img src="assets/search.png" class="button-icon" />
                        <span>Search</span>
                    </div>
                    <div class="each-action-section dynamic-columns-section">
                        <img
                            src="assets/column-filter.png"
                            class="button-icon"
                            (click)="show_toggle_columns = !show_toggle_columns"
                        />
                        <div class="dynamic-columns" *ngIf="show_toggle_columns">
                            <div class="dynamic-column-heading-section">
                                <span>Add Columns</span>
                                <span class="columns-close" (click)="show_toggle_columns = false">&times;</span>
                            </div>
                            <div class="dynamic-column-content">
                                <div class="each-column-section" *ngFor="let column of table_columns">
                                    <mat-checkbox [checked]="column.checked == true" (change)="column.checked = !column.checked">{{ column.name }}</mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <button class="move-button" (click)="moveToSalesProcess()">Move</button> -->
                </div>
            </div>
            <div class="new-table-v2-overflow">
                <!-- <table class="new-table"> -->
                    <table class="new-table-v2">
                        <thead>
                            <tr>
                                <!-- <th>
                                    <mat-checkbox [checked]="is_selected" (change)="selectAll($event)"></mat-checkbox>
                                </th> -->
                                <!-- <th>
                                    <div class="record-selection-section">
                                        <mat-checkbox [checked]="is_selected" (change)="selectAll($event)"></mat-checkbox>
                                    </div>
                                </th> -->
                                <th appColumnResizable>Actions</th>
                                <!-- <th appColumnResizable>Activities</th> -->
                                <th appColumnResizable>Activities</th>
                                <ng-container *ngFor="let column of table_columns">
                                    <th appColumnResizable *ngIf="column.checked">{{ column.name }}</th>
                                </ng-container>
                            </tr>
                        </thead>
                        <ng-container *ngIf="table_data_loaded">
                            <tbody *ngIf="table_data.length > 0">
                                <ng-container
                                *ngFor="
                                let client of table_data
                                | paginate
                                : {
                                    id: 'prospects-data',
                                    itemsPerPage: pagination_records_limit,
                                    currentPage: current_pagination_page,
                                    totalItems: total_pagination_records
                                };
                                let clientIndex = index
                                "
                                >
                                <tr>
                                    <!-- <td>
                                        <mat-checkbox [checked]="checkIndividualSelection(client)" (change)="selectIndividual($event, client)"></mat-checkbox>
                                    </td> -->
                                    <td>
                                        <div class="record-selection-section">
                                            <mat-checkbox [checked]="checkIndividualSelection(client)" (change)="selectIndividual($event, client)"></mat-checkbox>
                                        </div>
                                        <!-- <img
                                        src="assets/view-tasks.png"
                                        class="client-table-icon"
                                        (click)="openClientDataModal(client)"
                                        /> -->
                                        <img
                                        src="assets/view-tasks.png"
                                        class="client-table-icon"
                                        (click)="showUserProfile(client)"
                                        />
                                        <img src="assets/exclamation-icon.png" class="client-table-icon" *ngIf="client.trigger_status == 'Inactive'" [matTooltip]="client.trigger_description" />
                                    </td>
                                    <td>
                                        <img
                                        src="assets/ic-activities.png"
                                        class="client-table-icon"
                                        (click)="toggleActivityView(clientIndex)"
                                        />
                                    </td>
                                    <ng-container
                                    *ngFor="let column of table_columns"
                                    [ngSwitch]="column.key"
                                    >
                                    <ng-container *ngSwitchCase="'status'">
                                        <td *ngIf="column.checked">
                                            <p class="status-tag completed-status">
                                                {{ client.status }}
                                            </p>
                                        </td>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'ai_rank'">
                                        <td class="highlight-table-cell" *ngIf="column.checked">
                                            {{ getKey(client, column) }}
                                        </td>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'opportunity'">
                                        <td class="highlight-table-cell" *ngIf="column.checked">
                                            {{ getKey(client, column) }}
                                        </td>
                                    </ng-container>
                                    <ng-container
                                    *ngSwitchCase="'predicted_wallet_share_growth'"
                                    >
                                    <td class="highlight-table-cell" *ngIf="column.checked">
                                        {{ getKey(client, column) }}
                                    </td>
                                </ng-container>
                                <ng-container *ngSwitchCase="'predicted_closure_days'">
                                    <td class="highlight-table-cell" *ngIf="column.checked">
                                        {{ getKey(client, column) }} Day(s)
                                    </td>
                                </ng-container>
                                <ng-container *ngSwitchCase="'recommended_products'">
                                    <td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getKey(client, column)">
                                        {{ getKey(client, column) }}
                                    </td>
                                </ng-container>

                                <ng-container *ngSwitchCase="'preferred_channel'">
                                    <td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getKey(client, column)">
                                        {{ getKey(client, column) }}
                                    </td>
                                </ng-container>

                                <ng-container *ngSwitchCase="'type'">
                                    <td *ngIf="column.checked" [matTooltip]="getKey(client, column)">
                                        <span
                                        [ngClass]="{
                                            'need-attention-activity-status': getKey(client, column) == 'Retention',
                                            'new-leads-activity-status': getKey(client, column) == 'Client Engagement',
                                            'in-progress-activity-status': getKey(client, column) == 'Opportunity'
                                        }"
                                        >{{getKey(client, column)}}</span
                                        >
                                    </td>
                                </ng-container>
                                <ng-container *ngSwitchCase="'actions'">
                                    <td *ngIf="column.checked">
                                        <img
                                        src="assets/view-tasks.png"
                                        class="client-table-icon"
                                        (click)="openClientDataModal(client)"
                                        />
                                    </td>
                                </ng-container>
                                <ng-container *ngSwitchCase="'trigger'">
                                    <td *ngIf="column.checked">
                                        <span [style.color]="client['trigger_type'] == 'AI' ? '#f3a638' : '#4cb64c'">{{ getKey(client, column) }}</span>
                                    </td>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <td *ngIf="column.checked">
                                        {{ getKey(client, column) }}
                                    </td>
                                </ng-container>
                            </ng-container>
                        </tr>
                        <tr *ngIf="show_activity_view == clientIndex">
                            <!-- <td colspan="20">
                                <app-adv-da-assigned-activities
                                [tasks_data]="tasks_data"
                                [advisor_data]="client"
                                ></app-adv-da-assigned-activities>
                            </td> -->
                            <td colspan="9" class="page-inner-view" style="overflow: visible;">
                                <app-activities [selected_user_data]="client" [selected_page_action]="'Activities'" [selected_activity_type]="2" [selected_view_type]="'View'" [section_type]="'ai_assistant'" [activity_action_type]="'View'" (dataChanged)="dataChanged($event)"></app-activities>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
                <tbody *ngIf="table_data.length == 0">
                    <td colspan="10">
                        <div class="zero-state-section">
                            <span>No Data Found</span>
                        </div>
                    </td>
                </tbody>
            </ng-container>
            <ng-container *ngIf="!table_data_loaded">
                <tbody>
                    <tr>
                        <td
                        colspan="15"
                        class="zero-state-section"
                        style="height: 120px"
                        >
                        <!-- <ngx-spinner bdColor = "transparent" size = "medium" color = "#1B82EC" type = "ball-running-dots" [fullScreen] = "false"><p class="loading-state-text"> Loading... </p></ngx-spinner> -->
                        <app-loader
                        [loading_text]="'Loading Assigned Clients'"
                        ></app-loader>
                    </td>
                </tr>
            </tbody>
            </ng-container>
            </table>
            </div>
            <!-- <div class="new-pagination-section"> -->
            <div class="new-table-v2-pagination-section">
                <span class="mx-4">{{ total_pagination_records | number:'1.0-0' }} Records</span>
                <mat-select
                class="pagination-input"
                [(ngModel)]="pagination_records_limit"
                (selectionChange)="current_pagination_page = 1; getClientsData()"
                >
                <mat-option [value]="10">10</mat-option>
                <mat-option [value]="100">100</mat-option>
                <mat-option [value]="500">500</mat-option>
                <mat-option [value]="1000">1000</mat-option>
            </mat-select>
            <!-- <div class="new-pagination-controls"> -->
                <div class="new-table-v2-pagination-controls">
                    <pagination-controls
                    id="prospects-data"
                    (pageChange)="pageChanged($event)"
                    style="text-align: right; position: relative; top: 6px"
                    ></pagination-controls>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="!page_loaded">
	<!-- <app-loader [loading_text]="'Loading AI Advisor Assistants'"></app-loader> -->
	<app-loader [loading_text]="'Loading MAGI'"></app-loader>
</div>

<ng-template #clientDataModal>
	<div class="modal-section client-details-modal">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Know Your Client</span>
			<span class="client-modal-icon" (click)="closeClientDataModal()"
			>&times;</span
			>
		</div>
		<div class="modal-content-section" *ngIf="!selected_modal_client_loader">
			<app-client-profile [client_data]="selected_client"></app-client-profile>
		</div>
		<div class="modal-content-section" *ngIf="selected_modal_client_loader">
			<app-loader [loading_text]="'Loading Client Profile'"></app-loader>
		</div>
	</div>
</ng-template>

<ng-template #assignAIAdvisorAssistantModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section">
			<span>Capture Response
				<div class="section-heading-tooltip-block">
					<img src="assets/info-black.png" />
					<div
					class="section-heading-tooltip-section"
					style="width: 300px;"
					>
					<p [innerHTML]="tooltipText"></p>
				</div>
			</div>
		</span>
		<span
		class="page-modal-close-icon"
		(click)="closeAssignAIAdvisorAssistantModal()"
		>&times;</span
		>
	</div>
	<div class="page-modal-content-section">
		<div class="page-modal-input-section">
			<p class="page-modal-input-label">Response Status</p>
			<mat-select class="page-modal-input" [(ngModel)]="ai_advisor_assistant" (selectionChange)="ai_advisor_assistant_activity_status = ''; ai_advisor_assistant_comments = ''; ai_advisor_assistant_activity_status_error = false; ai_advisor_assistant_comments_error = false;">
				<mat-option [value]="''">Select Response Status</mat-option>
				<mat-option [value]="'Interested'">Interested</mat-option>
				<mat-option [value]="'Not Interested'">Not Interested</mat-option>
			</mat-select>
			<p class="page-modal-input-error" *ngIf="ai_advisor_assistant_error">
				Response Status is Required.
			</p>
		</div>
		<div class="page-modal-input-section" *ngIf="ai_advisor_assistant == 'Interested'">
			<p class="page-modal-input-label">Select Activities Status</p>
			<mat-select class="page-modal-input" [(ngModel)]="ai_advisor_assistant_activity_status">
				<mat-option [value]="''">Select Activities Status</mat-option>
				<mat-option [value]="'No'">Transfer the Client and mark their Pending Activities as 'Not Required'</mat-option>
				<mat-option [value]="'Yes'">Transfer Client & Pending Activities</mat-option>
			</mat-select>
			<p class="page-modal-input-error" *ngIf="ai_advisor_assistant_activity_status_error">
				Activities Status is Required.
			</p>
		</div>
		<div class="page-modal-input-section" >
			<!-- <p class="page-modal-input-label">Select Sales Process</p> -->
			<p class="page-modal-input-label">Select Process</p>
			<mat-select class="page-modal-input" [(ngModel)]="ai_advisor_assistant_sales_process">
				<!-- <mat-option [value]="''">Select Sales Process</mat-option> -->
				<mat-option [value]="''">Select Process</mat-option>
				<mat-option [value]="'Opportunity'">Upside Opportunities</mat-option>
				<mat-option [value]="'Retention'">Retention Opportunities</mat-option>
			</mat-select>
			<!-- <p class="page-modal-input-error" *ngIf="ai_advisor_assistant_sales_process_error">
				Sales Process is Required.
			</p> -->
			<p class="page-modal-input-error" *ngIf="ai_advisor_assistant_sales_process_error">
				Process is Required.
			</p>
		</div>
		<div class="page-modal-input-section">
			<p class="page-modal-input-label">Comments</p>
			<textarea class="page-modal-input page-modal-textarea" [(ngModel)]="ai_advisor_assistant_comments"></textarea>
			<p class="page-modal-input-error" *ngIf="ai_advisor_assistant_comments_error">
				Comments is Required.
			</p>
		</div>
	</div>
	<div class="page-modal-footer-section">
		<button
		class="page-modal-primary-button"
		*ngIf="!assigning_ai_advisor_assistant_loader"
		(click)="moveToSalesProcess()"
		>
		Save
	</button>
	<button
	class="page-modal-primary-button"
	*ngIf="assigning_ai_advisor_assistant_loader"
	>
	Saving...
</button>
<button
class="page-modal-secondary-button"
(click)="closeAssignAIAdvisorAssistantModal()"
>
Cancel
</button>
</div>
</div>
</ng-template>

<ng-container *ngIf="show_user_profile">
	<app-customer-profile [data]="user_profile_data" [client_type]="'Client'" (profileClosed)="profileClosed($event)"></app-customer-profile>
</ng-container>
